var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 46,
    viewBox: "0 0 65 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0703125,
    width: 64,
    height: 45,
    rx: 22.5,
    fill: "#BF3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4967 21.3308C33.8349 21.3136 35.4276 21.4114 37.164 21.7509C37.164 21.7509 37.9161 21.9063 37.9216 22.6142C37.9216 22.6142 37.9659 24.312 37.9769 24.64C37.9769 24.6688 37.9769 24.6918 37.9769 24.7206C37.9769 24.8587 38.0156 25.5493 38.9392 26.1479L42.5226 28.3175C42.7383 28.4499 42.9761 28.5305 43.2249 28.5593C43.5457 28.5938 43.977 28.5593 44.3641 28.283C44.3862 28.2658 44.4083 28.2485 44.4305 28.237C44.6074 28.1161 45.4867 27.5061 45.9623 26.8788C46.0839 26.7176 46.1779 26.5277 46.2388 26.332C46.4876 25.5436 47.0517 23.0343 44.9724 20.8244C44.9724 20.8244 43.5567 19.3798 41.8701 18.5051C41.8701 18.5051 39.1161 17.0202 36.1023 16.7728C36.0967 16.7613 34.5926 16.5541 32.4967 16.5713C30.4008 16.5541 28.8966 16.7613 28.8966 16.7613C25.8828 17.0087 23.1288 18.4935 23.1288 18.4935C21.4367 19.3683 20.0265 20.8129 20.0265 20.8129C17.9472 23.0228 18.5113 25.5378 18.7657 26.3205C18.8265 26.5162 18.9205 26.7004 19.0422 26.8673C19.5122 27.4946 20.397 28.1046 20.574 28.2255C20.5961 28.2427 20.6182 28.2542 20.6403 28.2715C21.0274 28.5535 21.4588 28.5823 21.7795 28.5478C22.0284 28.519 22.2662 28.4384 22.4818 28.306L26.0653 26.1364C26.9833 25.5378 27.0275 24.8472 27.0275 24.7091C27.0275 24.6803 27.0275 24.6573 27.0275 24.6285C27.033 24.3005 27.0828 22.6027 27.0828 22.6027C27.0828 21.8948 27.8404 21.7394 27.8404 21.7394C29.5713 21.3999 31.1695 21.3078 32.5077 21.3193L32.4967 21.3308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/endCall.8f547cb9af2128f37e4bccfe2dcf168e.svg";
export { ForwardRef as ReactComponent };